import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const QuickActionCard = ({ action }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (action?.path) {
      navigate(action?.path);
    }
  };

  return (
    <button
      onClick={handleClick}
      className="w-full bg-card border border-border rounded-lg p-4 hover:shadow-card hover:border-primary/50 transition-smooth text-left group"
    >
      <div className="flex items-start gap-3">
        <div className={`w-10 h-10 rounded-lg ${action?.bgColor} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-smooth`}>
          <Icon name={action?.icon} size={20} color={action?.iconColor} />
        </div>
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-semibold text-foreground mb-1 group-hover:text-primary transition-smooth">
            {action?.title}
          </h4>
          <p className="text-xs text-muted-foreground line-clamp-2">{action?.description}</p>
        </div>
        <Icon name="ChevronRight" size={16} className="text-muted-foreground flex-shrink-0 mt-1" />
      </div>
    </button>
  );
};

export default QuickActionCard;